import React from "react";
import { Button } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { HUB_STORES } from "../../../config/zinihubConfig";
import styles from "./EmptyState.module.css";

const EmptyState = React.memo(function EmptyState({
  type = "noShops",
  onCreateBusiness,
  leftAlign,
  createBusinessDisabled,
  createBusinessDisabledReason,
}) {
  const isNoResults = type === "noResults";

  if (isNoResults) {
    return (
      <div className={`${styles.empty} ${leftAlign ? styles.emptyLeft : ""}`}>
        <div className={styles.illustration}>
          <SearchOutlined />
        </div>
        <h3 className={styles.emptyTitle}>No results found</h3>
        <p className={styles.emptyText}>
          Try adjusting your search or filters to find what you're looking for.
        </p>
      </div>
    );
  }

  if (type === "makeLive") {
    return (
      <div className={`${styles.banner} ${leftAlign ? styles.bannerLeft : ""}`}>
        <img
          className={styles.bannerImg}
          src={`${process.env.PUBLIC_URL}/create-first-business.jpg`}
          alt="It's time to make your business live"
        />
        <div className={styles.bannerBody}>
          <h3 className={styles.bannerTitle}>It's time to make your business live</h3>
        </div>
      </div>
    );
  }

  if (type === "trashEmpty") {
    return (
      <div className={`${styles.empty} ${leftAlign ? styles.emptyLeft : ""}`}>
        <div className={styles.illustration}>
          <SearchOutlined />
        </div>
        <h3 className={styles.emptyTitle}>Trash is empty</h3>
        <p className={styles.emptyText}>Your deleted businesses will appear here.</p>
      </div>
    );
  }

  return (
    <div className={`${styles.banner} ${leftAlign ? styles.bannerLeft : ""}`}>
      <img
        className={styles.bannerImg}
        src={`${process.env.PUBLIC_URL}/create-first-business.jpg`}
        alt="Create your first business"
      />
      <div className={styles.bannerBody}>
        <h3 className={styles.bannerTitle}>No businesses yet</h3>
        <p className={styles.bannerText}>
          Create your first business to start selling and managing your products.
        </p>
        <Button
          type="primary"
          size="large"
          icon={<PlusOutlined />}
          data-guide-target="guide-create-business"
          className={styles.emptyBtn}
          onClick={onCreateBusiness}
          disabled={createBusinessDisabled}
          title={createBusinessDisabledReason || undefined}
        >
          {HUB_STORES.CREATE_FIRST_BUSINESS}
        </Button>
      </div>
    </div>
  );
});

export default EmptyState;
